// src/app/core/ui/FloatingBackground.tsx
import { useEffect, useMemo, useState } from 'react';
import { motion } from 'motion/react';
import { useTheme } from '@/app/core/ui/theme/ThemeProvider';

const BUBBLE_COUNT = 16;

  const lightColors = ['#c084fc', '#e879f9', '#38bdf8', '#facc15', '#2dd4bf', '#f43f5e', '#818cf8'];
  const darkColors = ['#8b5cf6', '#ec4899', '#3b82f6', '#f59e0b', '#10b981', '#f43f5e', '#6366f1'];
export const FloatingBackground = () => {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark';
  const [shouldAnimate, setShouldAnimate] = useState(false);

  // Запускаем анимации через 100 мс, чтобы дать странице отрисоваться
  useEffect(() => {
    const timer = setTimeout(() => setShouldAnimate(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const colors = isDark ? darkColors : lightColors;

  const bubbles = useMemo(() => {
    return Array.from({ length: BUBBLE_COUNT }).map((_, i) => ({
      id: i,
      size: 80 + Math.random() * 120,
      x: Math.random() * 100,
      y: Math.random() * 100,
      color: colors[i % colors.length],
      duration: 15 + Math.random() * 25,
      delay: Math.random() * 5,
    }));
  }, [colors]); 

  return (
      <div
        className="fixed inset-0 pointer-events-none overflow-hidden"
        style={{ zIndex: 0 }}
        key={isDark ? 'dark' : 'light'}
      >
      {bubbles.map((bubble) => (
        <motion.div
          key={bubble.id}
          className="absolute rounded-full will-change-transform"
          style={{
            width: bubble.size,
            height: bubble.size,
            backgroundColor: bubble.color,
            opacity: isDark ? 0.2 : 0.15,
            filter: 'blur(40px)',
            left: `${bubble.x}%`,
            top: `${bubble.y}%`,
          }}
          animate={
            shouldAnimate
              ? {
                  x: [0, 30, -20, 10, 0],
                  y: [0, -20, 10, -30, 0],
                  scale: [1, 1.1, 0.95, 1.05, 1],
                }
              : { opacity: 0 } // до старта анимации пузыри невидимы
          }
          transition={{
            duration: bubble.duration,
            repeat: Infinity,
            delay: bubble.delay,
            ease: 'easeInOut',
          }}
        />
      ))}
    </div>
  );
};